import { Component, input } from '@angular/core';

@Component({
  selector: 'app-custom-actions-alert',
  standalone: false,
  templateUrl: './custom-actions-alert.component.html',
  styleUrl: './custom-actions-alert.component.scss',
})
export class CustomActionsAlertComponent {
  readonly model = input<any>();
  readonly actionsGroupName = input<string>('');
  readonly bannerText = input<string>('');
}
